// extracted by mini-css-extract-plugin
export default {"wrapper":"ZU-z","availablePromoMessagesLabel":"_U-z","promoMessageList":"aV-z","promoMessage":"bV-z","appliedPromoMessage":"cV-z","promoMessageAmount":"dV-z"};